// @ts-nocheck
import { useState, useEffect, useReducer } from 'react';
import { Button } from 'primereact/button';
import { Divider } from 'primereact/divider';
import { Card } from 'primereact/card';
import { InputSwitch } from 'primereact/inputswitch';
import { Slider } from 'primereact/slider';
import { Dropdown } from 'primereact/dropdown';
import reactCSS from 'reactcss';
import { SketchPicker } from 'react-color';
import "../../assets/functionalComponents/_dialog.scss"
import "../../assets/functionalComponents/_dataItem.scss"

export const PointCloudOption = (props) => {
    const [layer, setLayer] = useState({});
    const [optionOpen, setOptionOpen] = useState(false);
    const [EDLtoggle, setEDLtoggle] = useState(false);
    const [EDLScale, setEDLScale] = useState(0);
    const [altitudetoggle, setAltitudetoggle] = useState(false);
    const [drawModeList,] = useState([
        { value: 0, label: "單色漸層" },
        { value: 1, label: "分層設色" }
    ]);
    const [drawMode, setDrawMode] = useState(0);
    const [color, setColor] = useState({
        r: 241,
        g: 112,
        b: 19,
        a: 1,
    });
    const [displayColorPicker, setDisplayColorPicker] = useState(false);
    const [, forceUpdate] = useReducer(num => num + 1, 0);

    const styles = reactCSS({
        'default': {
            color: {
                width: '100%',
                height: '14px',
                borderRadius: '2px',
                background: `rgba(${color.r}, ${color.g}, ${color.b}, ${color.a})`,
            },
            swatch: {
                padding: '5px',
                width: '100%',
                background: '#fff',
                borderRadius: '10px',
                boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
                display: 'inline-block',
                cursor: 'pointer',
            },
            popover: {
                position: 'relative',
                zIndex: '2000'
            },
            cover: {
                position: 'fixed',
                top: '0px',
                right: '0px',
                bottom: '0px',
                left: '0px',
            },
        },
    });

    useEffect(() => {
        setLayer(props.layer)
        if (props.layer.layerSetting) {
            setOptionOpen(props.layer.layerSetting.optionOpen);
            setEDLtoggle(props.layer.layerSetting.EDLtoggle);
            setEDLScale(props.layer.layerSetting.EDLScale);
            setAltitudetoggle(props.layer.layerSetting.altitudetoggle);
            setDrawMode(props.layer.layerSetting.drawMode);
            setColor(props.layer.layerSetting.color);
        }
    }, [props.layer])

    useEffect(() => {
        let item = props.layer;
        item.layerSetting = {
            optionOpen: optionOpen,
            EDLtoggle: EDLtoggle,
            EDLScale: EDLScale,
            altitudetoggle: altitudetoggle,
            drawMode: drawMode,
            color: color
        };
        props.layerUpdate(item, props.index);
    }, [optionOpen, EDLtoggle, EDLScale, altitudetoggle, drawMode, color]);

    useEffect(() => {
        props.layer.layerObject.enableEDL(EDLtoggle);
    }, [props.layer, EDLtoggle])

    useEffect(() => {
        props.layer.layerObject.edlStrength = EDLScale;
        window.main.OView.updateScreen();
    }, [props.layer, EDLScale])

    useEffect(() => {
        let layerHandel = props.layer.layerObject;
        let AltitudeMin = layerHandel.getAltitude().AltitudeMin;
        let AltitudeMax = layerHandel.getAltitude().AltitudeMax;
        let gap;
        layerHandel.enableAltitudeMode(altitudetoggle);
        if (altitudetoggle) {
            if (drawMode === 0) {
                gap = (AltitudeMax - AltitudeMin) / 4;
                layerHandel.setColorSet(
                    [
                        color.r, color.g, color.b, color.a,
                        color.r * 0.75, color.g * 0.75, color.b * 0.75, color.a,
                        color.r * 0.5, color.g * 0.5, color.b * 0.5, color.a,
                        color.r * 0.25, color.g * 0.25, color.b * 0.25, color.a,
                        0, 0, 0, color.a,
                    ],
                    [AltitudeMax, AltitudeMax - gap, AltitudeMax - gap * 2, AltitudeMax - gap * 3, AltitudeMax - gap * 4]
                );
                window.main.OView.updateScreen();
            }
            else if (drawMode === 1) {
                gap = (AltitudeMax - AltitudeMin) / 3;
                layerHandel.setColorSet(
                    [
                        255, 0, 0, 255,
                        255, 255, 0, 255,
                        0, 128, 0, 255,
                        0, 0, 0, 255,
                    ],
                    [AltitudeMax, AltitudeMax - gap, AltitudeMax - gap * 2, AltitudeMax - gap * 3]
                );
                window.main.OView.updateScreen();
            }
        }
    }, [altitudetoggle, drawMode, color])

    const handleChange = (color) => {
        let layerHandel = props.layer.layerObject;
        let AltitudeMin = layerHandel.getAltitude().AltitudeMin;
        let AltitudeMax = layerHandel.getAltitude().AltitudeMax;
        let gap = (AltitudeMax - AltitudeMin) / 4;
        setColor(color.rgb);
        layerHandel.setColorSet(
            [
                color.rgb.r, color.rgb.g, color.rgb.b, color.rgb.a,
                color.rgb.r * 0.75, color.rgb.g * 0.75, color.rgb.b * 0.75, color.rgb.a,
                color.rgb.r * 0.5, color.rgb.g * 0.5, color.rgb.b * 0.5, color.rgb.a,
                color.rgb.r * 0.25, color.rgb.g * 0.25, color.rgb.b * 0.25, color.rgb.a,
                0, 0, 0, color.rgb.a,
            ],
            [AltitudeMax, AltitudeMax - gap, AltitudeMax - gap * 2, AltitudeMax - gap * 3, AltitudeMax - gap * 4]
        );
        window.main.OView.updateScreen();
        forceUpdate();
    }

    const OptionCard = () => {
        return (
            <Card style={{ marginTop: "1rem" }}>
                <div className="field grid">
                    <label class="col-12 mb-4 md:col-4 md:mb-0">邊界增強模式：</label>
                    <div className="col-12 md:col-8">
                        <InputSwitch checked={EDLtoggle} onChange={(e) => setEDLtoggle(e.value)} />
                    </div>
                </div>
                {
                    EDLtoggle ?
                        <div>
                            <div className='slider-description'>增強強度： {EDLScale} </div>
                            <Slider id="EDLScale" value={EDLScale} onChange={(e) => setEDLScale(e.value)} min={0} max={100} />
                        </div> : null
                }
                <Divider />
                <div className="field grid">
                    <label class="col-12 mb-4 md:col-4 md:mb-0">高度著色模式：</label>
                    <div className="col-12 md:col-8">
                        <InputSwitch checked={altitudetoggle} onChange={(e) => setAltitudetoggle(e.value)} />
                    </div>
                </div>
                {
                    altitudetoggle ?
                        <div className="field grid">
                            <label htmlFor="drawModeDropdown" class="col-12 mb-4 md:col-4 md:mb-0">著色模式：</label>
                            <div className="col-12 md:col-8">
                                <Dropdown className="inputfield w-full" inputId="drawModeDropdown" value={drawMode} options={drawModeList} onChange={(e) => setDrawMode(e.value)} optionLabel="label" placeholder="Select Model." />
                            </div>
                        </div> : null
                }
                {
                    altitudetoggle && drawMode === 0 ?
                        <div className="field grid">
                            <label class="col-12 mb-4 md:col-4 md:mb-0">著色顏色：</label>
                            <div className="col-12 md:col-8" style={{ alignSelf: 'center' }}>
                                <div style={{ textAlign: 'center' }}>
                                    <div style={styles.swatch} onClick={() => setDisplayColorPicker(!displayColorPicker)}>
                                        <div style={styles.color} />
                                    </div>
                                    {
                                        displayColorPicker ?
                                            <div style={styles.popover}>
                                                <div style={styles.cover} onClick={() => setDisplayColorPicker(false)} />
                                                <SketchPicker color={color} onChange={handleChange} />
                                            </div> : null
                                    }
                                </div>
                            </div>
                        </div> : null
                }
            </Card>
        )
    }
    const layerGoto = () => {
        layer.layerObject.goto();
    }

    return (
        <div>
            <div className="layer-item">
                <div className="layer-detail">
                    <div className="layer-name">{layer.TITLE}</div>
                </div>
                <div className="layer-action">
                    <Button icon="pi pi-cog" className="p-button-rounded p-button-info" onClick={() => { setOptionOpen(!optionOpen) }} />
                    <Button icon="pi pi-map-marker" className="p-button-rounded p-button-info" onClick={() => { layerGoto() }} />
                    <Button icon="pi pi-times" className="p-button-rounded p-button-danger" onClick={() => { props.layerRemove(props.index) }} />
                </div>
            </div>
            {
                optionOpen ? OptionCard() : null
            }
            <Divider />
        </div>
    )
}